import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

class UsageTrackingService {
    async trackOpen(componentName, componentType, feature) {
        try {
            const authUser = JSON.parse(localStorage.getItem('authUser'));
            await axios.post(
                `${process.env.REACT_APP_API_URL}/api/v1/usage-tracking/event`,
                {
                    userId: authUser?.id || authUser?._id,
                    email: authUser?.email,
                    componentName,
                    componentType,
                    feature,
                },
                { headers: getAuthHeaders(true) }
            );
        } catch (error) {
            console.error('Failed to record usage event', error);
        }
    }

    async getUsageStats(startDate, endDate) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/usage-tracking/stats`, {
                headers: getAuthHeaders(true),
                params: { startDate, endDate },
            });
            return response.data;
        } catch (error) {
            console.error('Failed to fetch usage stats', error);
            return [];
        }
    }

    async clearAllUsageData() {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/v1/usage-tracking/clear-all-data`, {
            headers: getAuthHeaders(true),
        });
        return response.data;
    }
}

export default new UsageTrackingService();
